// extracted by mini-css-extract-plugin
export default {"container":"form-links_container__eQKYk","item":"form-links_item__BFHfI","label":"form-links_label__GxZQb","link":"form-links_link__3+izj"};